import type { ContentBlock } from '@lingoda/monolith-graphql';
import { PurchaseType } from '@lingoda/monolith-graphql';
import { DangerousHtml, Stack, Typography } from '@lingoda/ui';
import { trans } from '@lingoda/i18n';
import { type CheckoutPurchase } from '../types';
import { Agreements, AgreementsSprint } from './Agreements';

interface Props {
    purchase: CheckoutPurchase;
    terms?: ContentBlock[];
}

const TermsAndConditionsSection = ({ purchase, terms = [] }: Props) => {
    const AgreementsComponent =
        purchase.type === PurchaseType.Sprint ? AgreementsSprint : Agreements;

    return (
        <Stack spacing={3}>
            <Typography variant="h2">
                {trans('footer.lingoda.terms', {}, 'public-common')}
            </Typography>
            {terms.length > 0 && (
                <Stack spacing={1}>
                    {terms.map((term, i) => (
                        <Typography key={i} variant="body1">
                            <DangerousHtml>{term.text}</DangerousHtml>
                        </Typography>
                    ))}
                </Stack>
            )}

            <AgreementsComponent
                agreements={purchase.agreements}
                showRevocationLink={purchase.isSubscription}
            />
        </Stack>
    );
};

export default TermsAndConditionsSection;
